export default {
  productNotFound: {
    id: 'buyback_product_page_not_found',
    defaultMessage: 'Product not found',
  },
  breadcrumbAriaLabel: {
    id: 'buyback_breadcrumb_aria_label',
    defaultMessage: 'Breadcrumb product page trade in',
  },
}
